import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';
import { Easing, Tween } from '@tweenjs/tween.js';
import { delay } from '../../../Utility/Task/TaskQueue';
import { RenderSystemEvent } from '../../Render/RenderSystem';
import { report } from '../../../report';
import { MathHelper } from 'Utility/MathHelper';
import TextComponent from 'Component/Render/Text';

interface ISeasonPassProgressData {
    progressFill: GameObject;
    progressMilestone: GameObject;
    progressText: GameObject;
    progress: number;
    progressMaxWidth: number;
    progressTextValue: string;
    milestoneTextValue: string;
    reset?: boolean;
    initialDelay?: number;
    duration: number;
    onComplete?: () => void;
}

export class SeasonPassProgress extends AnimationClip<ISeasonPassProgressData> {
    public *execute(animator: GameObject, meta: ISeasonPassProgressData): IterableIterator<number> {
        try {
            animator.scene.emit(RenderSystemEvent.BRING_TO_FRONT, animator);

            if (meta.initialDelay) {
                yield* delay(meta.initialDelay);
            }

            if (meta.reset === true) {
                yield* delay(500);
                yield* this.resetProgressBar(meta.progressFill);
            } else {
                yield* this.fillProgressBar(meta.progressFill, meta.progress, meta.progressMaxWidth, meta.duration);
            }

            meta.progressText.getComponent(TextComponent).text = meta.progressTextValue;
            meta.progressMilestone.getComponent(TextComponent).text = meta.milestoneTextValue;

            if (meta.onComplete) {
                meta.onComplete();
            }

        } catch (error) {
            report('SeasonPassProgress failed', { error, once: true });
        }
    }

    private *fillProgressBar(progressFill: GameObject, progress: number, maxWidth: number, duration: number) {
        const fillTransform = progressFill.getComponent(TransformComponent);
        const tweenWidth: Tween = this.getTween(fillTransform);
        const progressWidth = Math.min(
            MathHelper.lerp(0, maxWidth, progress),
            maxWidth
        );

        tweenWidth.to({ width: progressWidth }, duration).easing(Easing.Quartic.InOut);
        yield* this.startTween(tweenWidth);
    }

    private *resetProgressBar(progressFill: GameObject) {
        const fillTransform = progressFill.getComponent(TransformComponent);
        const tweenWidth: Tween = this.getTween(fillTransform);

        // Animate width back to 0
        tweenWidth.to({ width: 0 }, 200).easing(Easing.Quartic.Out);
        yield* this.startTween(tweenWidth);
    }
}
